import { Stack } from "@mui/material";
const Stack_Stack = Stack;
export { Stack_Stack as Stack };

//# sourceMappingURL=Stack.js.map